import type { EndUserAppsPageProps, PageProps } from "@/types";
import React, { FC } from "react";
import {
  EndUserAppsEngageWithUsers,
  EndUserAppsHero,
  EndUserAppsIndividualTransfers,
} from "../end-user-apps";
import { EndUserAppsSimplifyPaying } from "../end-user-apps/simplify-paying";

export const EndUserApps: FC<PageProps<EndUserAppsPageProps>> = (props) => {
  return (
    <div>
      <EndUserAppsHero
        label={props.meta.translation.solutions.hero.label}
        title={props.data.title}
        description={props.data.description}
        cover={props.data.cover}
      />
      <EndUserAppsSimplifyPaying
        content={props.data.simplifyPayingContent}
        tags={props.data.simplifyPayingTags}
      />
      <EndUserAppsIndividualTransfers
        content={props.data.individualTransfersContent}
        cover={props.data.individualTransfersCover}
      />
      <EndUserAppsEngageWithUsers
        content={props.data.engageWithUsersContent}
        cover={props.data.engageWithUsersCover}
      />
    </div>
  );
};
